export enum Segment {
	seconds = 'seconds',
	minutes = 'minutes',
	hours = 'hours',
	dayOfMonth = 'dayOfMonth',
	month = 'month',
	dayOfWeek = 'dayOfWeek',
	year = 'year'
}
